import React, { useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "primereact/dropdown";

import {
  getBranches,
  GetBusinessesList,
} from "../../store/slices/BusinessSlice";
import i18next from "i18next";
import SharedButton from "../../components/Shared/SharedButton";
import { AutoComplete } from "primereact/autocomplete";
import { fetchData } from "../../helpers/fetchData";
import DatePicker from "../../components/Shared/DatePicker";
import DropdownComponent from "../../components/Shared/DropdownComponent";
import AutoCompleteField from "../../components/Shared/AutoCompleteField";

const CompanyInvoiceFilters = ({
  filters,
  setFilters,
  handleAddFilters,
  filterLoading,
  handleResetFilters,
  filteredInvoices,
}) => {
  const { t } = useTranslation();
  const lang = i18next.language;
  const dispatch = useDispatch();
  const { branches } = useSelector((state) => state.business);
  const { businessList } = useSelector((state) => state.business);
  const [customers, setCustomers] = useState([]);

  const listBranchvalues = branches?.data
    ? Object.entries(branches?.data).map(([id, branch]) => ({
        value: Number(branch?.id),
        label: lang === "ar" ? branch.name_ar : branch.name_en,
      }))
    : [];

  const listCompaniesvalues = businessList?.data
    ? Object.entries(businessList?.data).map(([id, company]) => ({
        value: Number(company?.license_id),
        label: lang === "ar" ? company.name_ar : company.name_en,
      }))
    : [];

  const payment_method_values = [
    { value: "cash", label: lang === "ar" ? "نقدي" : "Cash" },
    { value: "bank", label: lang === "ar" ? "بنك" : "Bank" },
    { value: "mada", label: lang === "ar" ? "مدى" : "MADA" },
    { value: "cheque", label: lang === "ar" ? "يفحص" : "Cheque" },
  ];

  useEffect(() => {
    dispatch(GetBusinessesList({ page: 1, per_page: 100 }));
    dispatch(getBranches());
  }, []);

  const handleComplete = (event) => {
    fetchCustomers(event.query);
  };

  const fetchCustomers = async (query) => {
    let payload = { query };
    const data = await fetchData("POST", "searchCustomer", payload);
    if (data) {
      const listAccountsValues = data?.data
        ? Object.entries(data?.data).map(([id, customer]) => ({
            value: Number(customer?.id),
            label: customer?.name + " " + customer?.secondary_contact_number,
          }))
        : [];
      setCustomers(listAccountsValues);
    }
  };

  return (
    <div>
      <div className="flex flex-col md:flex-row md:items-center mb-2 gap-2">
        <DatePicker
          useFormik={false}
          // label={t("StartDate")}
          value={filters?.start_date ? new Date(filters.start_date) : null}
          onChange={(e) =>
            setFilters((prev) => ({
              ...prev,
              start_date: e.value
                ? new Date(
                    e.value.getTime() - e.value.getTimezoneOffset() * 60000,
                  )
                    .toISOString()
                    .split("T")[0]
                : "",
            }))
          }
        />
        <DatePicker
          useFormik={false}
          // label={t("EndDate")}
          value={filters?.end_date ? new Date(filters.end_date) : null}
          onChange={(e) =>
            setFilters((prev) => ({
              ...prev,
              end_date: e.value
                ? new Date(
                    e.value.getTime() - e.value.getTimezoneOffset() * 60000,
                  )
                    .toISOString()
                    .split("T")[0]
                : "",
            }))
          }
        />
        <DropdownComponent
          useFormik={false}
          // label={t("payment_method")}
          value={filters?.payment_method}
          options={payment_method_values}
          handleChange={(e) =>
            setFilters((prev) => ({ ...prev, payment_method: e.value }))
          }
          placeholder={t("payment_method")}
          showClear
        />
        <DropdownComponent
          useFormik={false}
          // label={t("select_company")}
          value={filters?.company_id}
          options={listCompaniesvalues}
          handleChange={(e) =>
            setFilters((prev) => ({ ...prev, company_id: e.value }))
          }
          placeholder={t("select_company")}
          showClear
        />
        <DropdownComponent
          useFormik={false}
          // label={t("select_branch")}
          value={filters?.branch_id}
          options={listBranchvalues}
          handleChange={(e) =>
            setFilters((prev) => ({ ...prev, branch_id: e.value }))
          }
          placeholder={`${t("select")} ${t("branch")}`}
          showClear
        />
        <AutoCompleteField
          useFormik={false}
          // label={t("select_customer")}
          placeholder={t("select_customer")}
          value={filters?.customer_id}
          fieldUrl="searchCustomer"
          suggestions={customers}
          completeMethod={(e) => fetchCustomers(e.query)}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, customer_id: e.value }))
          }
        />
        <div className="">
          <SharedButton
            disabled={filterLoading}
            title={t("apply_filters")}
            icon="pi pi-filter"
            onClick={handleAddFilters}
          />
        </div>
        <div className="">
          <SharedButton
            disabled={filterLoading}
            buttonType="reset"
            title={t("reset")}
            icon="pi pi-sync"
            onClick={handleResetFilters}
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyInvoiceFilters;
